import { createLazyFileRoute } from "@tanstack/react-router";

import { TestSpecsPage } from "@/features/admin/routes/TestSpecs";

export const Route = createLazyFileRoute("/_auth/admin/tests/")({
  component: TestSpecsPage,
});
